// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-grid[data-v-e5b45182]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;margin:0 -10px}.event-grid[data-v-e5b45182]:after{content:\"\";flex:auto}@media only screen and (max-width:1024px){.event-grid[data-v-e5b45182]{margin:0 -8px}}@media only screen and (max-width:768px){.event-grid[data-v-e5b45182]{margin:0 -6px}}@media only screen and (max-width:500px){.event-grid[data-v-e5b45182]{margin:0 -3px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
